import React, { useState, useEffect, useRef} from "react";
import { useDispatch} from "react-redux";
import {
	Paper,	
} from "@material-ui/core";
import cls from "./styles.module.scss";
import service from "../../redux/actions/common"
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom/cjs/react-router-dom";


const PersonalInformationList = () => {
	
	const dispatch = useDispatch()
	const ref = useRef()	
	const [dataHtml, setData] = useState("")
	const location = useLocation();		

	useEffect(() => {
		dataHtml && createIframe(dataHtml)
	}, [dataHtml]);

	//get data
	useEffect(() => {		

		if(location.pathname !== "/"){
			setData("")
			return
		}

		dispatch(service.personalInformationList((data)=> {
			
			if(data.resCode === 0)
			{					
				if(data.html){
					setData(data.html)				
					data.userMsg && toast.success(data.userMsg)
				}				
			} else {
				toast.success(data.userMsg || "Что-то пошло не так")
			}
			
		}, () => {					
		}))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	const createIframe = (html) => {
		const parentContainerRef = ref
		const newIframe = document.createElement('iframe')
		parentContainerRef.current.appendChild(newIframe)
		newIframe.contentWindow.document.open('text/html', 'replace')
		newIframe.contentWindow.document.write(html)
		newIframe.contentWindow.document.close()
		newIframe.addEventListener('load', function onIFrameLoad(e) {
			setTimeout(()=> {			
				var styles = newIframe.contentWindow.getComputedStyle(newIframe.contentWindow.document.body)
				var margin = parseFloat(styles['marginTop']) +	parseFloat(styles['marginBottom'])
				var height = Math.ceil(newIframe.contentWindow.document.body.offsetHeight + margin)
				newIframe.height = height + "px"				
			}, 100)
		});
	}
	
	return dataHtml && (
			<Paper className={`${cls.table_container} ${cls.iframe_container}`}>					
				<div ref={ref} className={cls.iframe_holder}></div>
			</Paper>
	)
};

export default PersonalInformationList;
